import styled from 'styled-components'
import posed from 'react-pose'

const Animation = posed.div({
  opened: {
    applyAtStart: { display: 'flex' },
    // height: 'auto',
    opacity: 1,
    transition: {
      duration: 300
    },
    staggerChildren: 10
  },
  closed: {
    afterChildren: true,
    applyAtEnd: { display: 'none' },
    // height: 10,
    opacity: 0,
    transition: {
      duration: 150
    },
    staggerChildren: 10
  }
})

// export default Animation

const MenuContainer = styled(Animation)`
  display: flex;
  flex-direction: column;
  position: absolute;
  ${'' /* z-index: 10; */}
  ${props => (props.isMobile || props.tallContainer ? 'bottom: 5px;' : 'top: 100%;')}
  right: 10px;
  padding: 4px;
  background: #ffffff;
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
`

export default MenuContainer
